import React, { Component } from 'react'
import Link from '../utils/link'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Triangle } from './icons' 
import TeamBlock from './team-block'
import Fade from 'react-reveal/Fade'

import Select from 'react-select'
import { Search } from './icons'

const areas = [
  { label: "Leadership", value: "Director" },
  { label: "Sales Representatives", value: "Sales Representative" },
  { label: "Property Management", value: "Property Management" },
  { label: "Administration", value: "Admin" },
  { label: "All Team Members", value: "" }
]

const states = [
  { label: "QLD", value: "QLD" },
  { label: "NSW", value: "NSW" }
]

class HeroBannerTeam extends Component {

  state = {
    searchPlaceholder: `Search for an agent`,
    search: '',
    office: null,
    area: null,
    location: null,
    count: 0,
  }

  constructor(props) {
    super(props)

    this.props.data.agents?.nodes?.sort((a, b) => {
      const aTitle = a?.title?.toLowerCase() || ''
      const bTitle = b?.title?.toLowerCase() || ''

      const aJob = a?.teamDetails?.jobTitle?.toLowerCase() || ''
      const bJob = b?.teamDetails?.jobTitle?.toLowerCase() || ''

      const aIsManaging = aJob.includes('managing director') ? 1 : 0
      const bIsManaging = bJob.includes('managing director') ? 1 : 0

      const aIsLeader = a?.acf?.leadership ? 1 : 0
      const bIsLeader = b?.acf?.leadership ? 1 : 0

      // Managing Director takes priority
      if (aIsManaging !== bIsManaging) return bIsManaging - aIsManaging

      // Then leadership
      if (aIsLeader !== bIsLeader) return bIsLeader - aIsLeader

      // Then alphabetical
      return aTitle.localeCompare(bTitle)
    })
    
  }

  componentDidMount() {
    this.updateDimensions()
    this.updateList()
    window.addEventListener("resize", this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  updateDimensions = () => {
    if(window.innerWidth < 900) {
      this.setState({ searchPlaceholder: `Search for a Team Member` });
    } else {
      this.setState({ searchPlaceholder: `Search for a Team Member` });
    }
  }

  handleChange = (option, field) => {
    //console.log(option, field)
    let state = {}
    switch (field && field.action) {
      case 'select-option':
        state[field.name] = option
        this.setState(state, this.updateList)
        break
      default:
        let { name, value } = option.currentTarget
        state[name] = value
        this.setState(state, this.updateList)
        break
    }
  }

  handleSubmit = e => {
    e.preventDefault()
    const el = document.querySelector('.team-block')
    const offset = el.getBoundingClientRect().top + window.scrollY - 120
    window && window.scrollTo({
      top: offset,
      behavior: 'smooth'
    })
  }

  updateList = () => {
    const { agents } = this.props.data
    const { search, area } = this.state

    let results = []

    if (agents?.nodes?.length > 0) {
      agents.nodes.forEach(agent => {
        const { title, teamDetails, acf, id } = agent
        if (!teamDetails) return

        let role = teamDetails.role
        if (role === 'Reception' || role === 'Personal Assistant') role = 'Admin'

        const jobTitle = teamDetails.jobTitle?.toLowerCase() || ''
        const selectedArea = area?.value || ''

        const roleMatches = selectedArea === '' || selectedArea === role
        const jobTitleMatches = selectedArea && jobTitle.includes(selectedArea.toLowerCase())
        const isDirectorMatch = selectedArea === 'Director' && acf?.leadership

        const matchesArea = roleMatches || jobTitleMatches || isDirectorMatch

        const searchableText = `${title} ${role} ${jobTitle}`.toLowerCase()
        const matchesSearch = !search || searchableText.includes(search.toLowerCase())

        if (matchesArea && matchesSearch) {
          results.push(agent)
        }
      })
    }

    this.setState({
      results,
      count: results.length
    })
  }


  render() {

    let { image, title, content, text, link } = this.props
    let { office, area, location, searchPlaceholder, results, count } = this.state

    return (
      <>
        <section className='hero-banner-team'>
          <div className='hero-banner-team__inner'>
              <div className='hero-banner-team__content'>
                <div className='hero-banner-team__details'>
                  <Fade bottom distance='40px' duration={1000}>
                  <h2 className='heading'>{ title }</h2>
                  <div className='hero-banner-team__form'>
                    <div className='form-container'>
                    <div className="search-team">
                      <div className="search-team__inner">
                        <form className="search-team__form form" onSubmit={this.handleSubmit}>
                          <div className='form__row form__row--search'>
                            <input className="form__input" type="text" name="search" placeholder={searchPlaceholder} onChange={this.handleChange} />
                            <button type='submit'>
                              <Search color={'#233356'} />
                            </button>
                          </div>
                          <div className="form__row form__row--dropdowns">
                            <div className='form__select form__select--area'>
                              <Select
                                options={areas}
                                onChange={this.handleChange}
                                openMenuOnFocus={true}
                                id="area"
                                name="area"
                                value={area}
                                placeholder="Area of Expertise"
                                className="react-select-container"
                                classNamePrefix="react-select"
                                ref={node => this.area = node}
                              />
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    </div>

                    <div className='copy' dangerouslySetInnerHTML={{ __html: content }} />
                  </div>
                  </Fade>
                  <Link to={link} className='hero-banner-team__link'>
                    <span>{ text }</span><Triangle color='#233356' />
                  </Link>
                </div>
                <div className='hero-banner-team__image'>
                  { image?.sourceUrl && <img src={image?.sourceUrl} alt={title} /> }
                </div>
              </div>
          </div>
        </section>
        <TeamBlock count={count} members={results} />
      </>
    )
  }
}

export default function TeamQuery(props) {
  return (
    <StaticQuery
      query={graphql`
      query TeamQuery {
        site {
          buildTime
        }
        agents: allWpTeamMember(filter: {databaseId: {ne: 16368}}, sort: {title: ASC}) {
          nodes {
            id
            title
            slug
            teamDetails {
              firstName
              lastName
              officeName
              mobile
              phone
              email
              jobTitle
              role
            }
            acf {
              contactNumber
              companyName
              thumbnailImage {
                sourceUrl
                altText
              }
              leadership
            }
          }
        }
      }
      `}
      render={data => (
        <HeroBannerTeam data={data} {...props} />
      )}
    />
  )
}
